export default class PicklistDetail {

    /***
     *
     * @param{PicklistInfo} picklistInfo
     */
    static getInstance(picklistInfo) {
        const picklistDetail = new PicklistDetail();
        picklistDetail.id = picklistInfo.id;
        picklistDetail.status = picklistInfo.status;
        picklistDetail.routeCode = picklistInfo.code;
        picklistDetail.activeCart = picklistInfo.cart;
        picklistDetail.routeAisles = picklistInfo.aisles;
        picklistDetail.stagingArea = picklistInfo.stagingArea;
        picklistDetail.chutes = picklistInfo.chutes;
        picklistDetail.executionMode = picklistInfo.executionMode;
        picklistDetail.scannedContent = picklistDetail.routeCode;
        return picklistDetail;
    }
}



// WEBPACK FOOTER //
// ./src/models/picklist-detail.js